import { Component, OnInit } from '@angular/core';
import { MessageService, SharedModule } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { MockService } from '../../../services/mock.service';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ToastModule } from 'primeng/toast';

interface Tool {
  icon: string;
  name: string;
}
@Component({
  selector: 'app-role-tools',
  standalone: true,
  imports: [SharedModule, TableModule, InputSwitchModule, ToastModule],
  templateUrl: './role-tools.component.html',
  styleUrl: './role-tools.component.scss',
})
export class RoleToolsComponent implements OnInit {
  access = false;
  tools: Tool[] = [];
  selectedTools: Tool[] = [];

  constructor(
    private mockService: MockService,
    private messageService: MessageService
  ) {}

  /**
   * A lifecycle hook that is called after Angular has initialized the component's data-bound properties.
   * In this implementation, it retrieves a list of tools from the mockService and assigns it to the tools property.
   *
   * @return {void} Does not return a value.
   */
  ngOnInit(): void {
    this.mockService.getTools().then(data => {
      this.tools = data;
    });
  }

  /**
   * Toggles the state of the access property and provides a feedback message
   * via the messageService indicating whether access was granted or denied.
   * @return {void} Does not return a value.
   */
  accessToggle(): void {
    this.access = !this.access;
    this.messageService.add(
      this.access
        ? {
            severity: 'success',
            summary: 'Aktualisiert',
            detail: 'Zugriff gewährt',
          }
        : {
            severity: 'error',
            summary: 'Aktualisiert',
            detail: 'Zugriff verweigert',
          }
    );
  }
}
